<template>
<div>
    <router-link v-if="$can('read-general-info', 'user')"
                 :to="'users/'+row.id+'/details'"
                 class="btn btn-sm btn-clean btn-icon btn-icon-sm"
    >
        <i class="fa fa-eye"></i>
    </router-link>
    <router-link v-if="$can('read-sensitive-info', 'user')"
                 :to="'users/'+row.id+'/activities-logs'"
                 class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                 :title="$t('label.show_activity_log')"
    >
        <i class="fa fa-history"></i>
    </router-link>

    <a v-show="$can('update', 'user')" v-if="row.is_deleted" href="#" v-on:click.prevent="restoreUser" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fa fa-sync-alt"></i>
    </a>
    <a v-show="$can('update', 'user')" v-else href="#" v-on:click.prevent="deleteUser" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fa fa-trash"></i>
    </a>
    <router-link v-if="$can('change-password', 'user')"
                 :to="'users/'+row.id+'/change-password'"
                 class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                 :title="$t('label.change-user-password')"
    >
        <i class="fa fa-key"></i>
    </router-link>

</div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import { userService } from '@/common/api.service'
import toastr from 'toastr'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        selector() {
            return $('tr[data-row="'+this.index+'"')
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-top-left",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
    methods : {
        deleteUser(e) {
            userService.delete(this.row.id).then(
                response => {
                    this.toastr.success(response.data.message)
                    this.row.is_deleted = true
                    // set status 3 to show user as a deleted
                    // just for showing
                    this.row.status = 3
                },
                error => {
                    //
                }
            )
        },
        restoreUser(e) {
            userService.restore(this.row.id).then(
                response => {
                    this.toastr.success(response.data.message)
                    this.row.is_deleted = false
                    this.row.status = 6
                    userService.find(this.row.id).then(
                        response => {
                            this.row.status = response.data.data.status
                        }
                    )
                },
                error => {
                    //
                }
            )
        }
    },
})
</script>